import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';
import { isEmpty } from 'lodash-es';

const assignmentBaseURL = `api/v1/assignments`;
const gradingBaseURL = `api/v1/assignment`;
const awardingBaseURL = `api/v1/badge`;

export function fetchAssignments(config: AxiosRequestConfig) {
  return v3.get(`${assignmentBaseURL}`, config);
}

export function updateExternalAssignments(payload) {
  return v3.put(`${gradingBaseURL}/grading`, payload);
}

export function awardBadgeForAssignment(assignmentId) {
  return v3.post(`${awardingBaseURL}?assignment_id=${assignmentId}`);
}
